import { Table } from "components/Datatable";
import { Badge, Box, Text } from "@adfenix/alexandria";
import dayjs from "dayjs";
import toPrice from "utils/toPrice";
import { useRecoilState } from "recoil";
import { jwtPayload } from "atoms/auth";
import { StripeService } from "@adfenix/types";
import { useTranslation } from "react-i18next";

export interface Props {
  data: StripeService.CustomerTransactions[] | undefined;
}

export const AllTransactionsTable = ({ data }: Props) => {
  const { t } = useTranslation();
  const [payload] = useRecoilState(jwtPayload);
  return (
    <Table
      pagination={data && data?.length > 10}
      keyField="id"
      defaultSortField="created"
      columns={[
        {
          name: t("billing_charge_history_date_column"),
          selector: (row: StripeService.CustomerTransactions) => row.created,
          cell: (row: StripeService.CustomerTransactions) => (
            <Text data-testid="transaction-date">
              {dayjs(row.created).format("MMM DD, YYYY")}
            </Text>
          )
        },
        {
          name: "",
          selector: (row: StripeService.CustomerTransactions) => row.paid,
          cell: (row: StripeService.CustomerTransactions) => (
            <Box>
              {row.paid ? (
                <Badge color="success" data-testid="transaction-status">
                  {t("billing_charge_history_paid_label")}
                </Badge>
              ) : (
                <Badge color="grey" data-testid="transaction-state">
                  {t("billing_charge_history_unpaid_label")}
                </Badge>
              )}
            </Box>
          )
        },

        {
          name: t("billing_charge_history_amount_column"),
          right: true,
          selector: (row: StripeService.CustomerTransactions) => row.amount,
          cell: (row: StripeService.CustomerTransactions) => (
            <Box pX="xs" data-testid="transaction-amount">
              {row.amount > 0
                ? toPrice(row.amount / 100, {
                    language: payload?.language,
                    currency: row.currency
                  })
                : "-"}
            </Box>
          )
        },
        {
          name: "",
          right: true,
          button: true,
          selector: (row: StripeService.CustomerTransactions) => row.receiptUrl,
          cell: (row: StripeService.CustomerTransactions) => (
            <Text>
              {" "}
              <a
                href={row.receiptUrl}
                target="_blank"
                rel="noreferrer"
                data-loglabel="view-receipt-link"
              >
                {t("billing_charge_history_view_receipt_label")}
              </a>
            </Text>
          )
        }
      ]}
      data={data || []}
    />
  );
};
